import { useEffect } from 'react'
import { useSession } from 'next-auth/react'
import { signOut } from 'next-auth/react'

export default function SessionHandler() {
  const { data: session } = useSession()
  useEffect(() => {
    const checkExpiration = () => {
      if (session?.expires) {
        const currentTime = Date.now()
        if (Number(currentTime) === Number(session?.expires)) {
          // 1 menit sebelum expired
          signOut({ callbackUrl: '/login' })
        }
      }
    }

    const interval = setInterval(checkExpiration, 30000)
    return () => clearInterval(interval)
  }, [session])

  return null
}
